import { render, staticRenderFns } from "./RegisterUI_Manage.vue?vue&type=template&id=f6dc4514&"
import script from "./RegisterUI_Manage.vue?vue&type=script&lang=js&"
export * from "./RegisterUI_Manage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUI_Manage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports